import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Scissors } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    // Idempotent guard — set synchronously to survive React StrictMode double-invoke.
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        if (data.session_token) localStorage.setItem("cm_token", data.session_token);
        setUser(data.user);
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch (err) {
        console.error("Google session exchange failed:", err);
        navigate("/login?error=oauth", { replace: true });
      }
    })();
    // Intentional one-time effect: this component exists only to exchange the
    // session_id on mount and then navigate away. Re-running on dep changes
    // would re-process a consumed session_id.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4">
      <Scissors className="w-8 h-8 text-copper animate-pulse" />
      <p className="cm-label">Signing you in…</p>
    </div>
  );
}
